"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUserForFranchiseReducer = exports.fetchUserForOwnerReducer = exports.verifyAdminOtpReducer = exports.sendAdminOtpReducer = exports.fOwnerLoginReducer = exports.adminLoginReducer = exports.verifyOtpReducer = exports.sendOtpReducer = exports.resetPasswordReducer = exports.updateUserProfileReducer = exports.updateUserReducer = exports.createUserReducer = exports.fetchUserByIdReducer = exports.fetchUserReducer = exports.getTokenWithRefreshTokenReducer = exports.getUserTokenWithRefreshTokenReducer = exports.logoutReducer = exports.businessLoginReducer = exports.userRegisterReducer = exports.userLoginReducer = exports.verifyAdminOtpSlice = exports.verifyOtpSlice = exports.sendAdminOtpSlice = exports.sendOtpSlice = exports.resetPasswordSlice = exports.updateUserProfileSlice = exports.updateUserSlice = exports.createUserSlice = exports.fetchUserByIdSlice = exports.fetchUserForFranchiseSlice = exports.fetchUserForOwnerSlice = exports.fetchUserSlice = exports.getTokenWithRefreshTokenSlice = exports.getUserTokenWithRefreshTokenSlice = exports.logoutSlice = exports.businessLoginSlice = exports.userRegisterSlice = exports.fOwnerLoginSlice = exports.adminLoginSlice = exports.userLoginSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const userActions_1 = require("./userActions");
const initialLoginState = {
    loginLoading: false,
    loginError: null,
    token: []
};
const initialRegisterState = {
    registerLoading: false,
    isRegister: false,
    registerError: null
};
const businessLoginState = {
    loginLoading: false,
    loginError: null,
    token: []
};
const getUserTokenWithRefreshTokenState = {
    loginLoading: false,
    loginError: null,
    token: []
};
const getTokenWithRefreshTokenState = {
    loginLoading: false,
    loginError: null,
    token: []
};
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchUserByIdInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateUserProfileInitialState = {
    loading: false,
    error: null,
    data: []
};
const resetPasswordInitialState = {
    loading: false,
    error: null,
    data: []
};
const sendOtpInitialState = {
    loading: false,
    error: null,
    data: []
};
const verifyOtpInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.userLoginSlice = (0, toolkit_1.createSlice)({
    name: 'user/login',
    initialState: initialLoginState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.login.pending, (state) => {
            state.loginLoading = true;
            state.loginError = null;
            state.token = [];
        })
            .addCase(userActions_1.login.fulfilled, (state, action) => {
            const tokenData = action.payload;
            state.loginLoading = false;
            state.loginError = null;
            // state.token = action.payload;
            localStorage.setItem('usertype', tokenData.usertype);
            localStorage.setItem('access_token', tokenData.access_token);
            localStorage.setItem('refresh_token', tokenData.refresh_token);
        })
            .addCase(userActions_1.login.rejected, (state, action) => {
            var _a;
            state.loginLoading = false;
            state.loginError = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to login';
            state.token = [];
        });
    }
});
exports.adminLoginSlice = (0, toolkit_1.createSlice)({
    name: 'user/adminLogin',
    initialState: initialLoginState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.adminLogin.pending, (state) => {
            state.loginLoading = true;
            state.loginError = null;
            state.token = [];
        })
            .addCase(userActions_1.adminLogin.fulfilled, (state, action) => {
            const tokenData = action.payload;
            state.loginLoading = false;
            state.loginError = null;
            // state.token = action.payload;
            localStorage.setItem('usertype', tokenData.usertype);
            localStorage.setItem('access_token', tokenData.access_token);
            localStorage.setItem('refresh_token', tokenData.refresh_token);
        })
            .addCase(userActions_1.adminLogin.rejected, (state, action) => {
            var _a;
            state.loginLoading = false;
            state.loginError = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to login';
            state.token = [];
        });
    }
});
exports.fOwnerLoginSlice = (0, toolkit_1.createSlice)({
    name: 'user/fOwnerLogin',
    initialState: initialLoginState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.fOwnerLogin.pending, (state) => {
            state.loginLoading = true;
            state.loginError = null;
            state.token = [];
        })
            .addCase(userActions_1.fOwnerLogin.fulfilled, (state, action) => {
            const tokenData = action.payload;
            state.loginLoading = false;
            state.loginError = null;
            // state.token = action.payload;
            localStorage.setItem('usertype', tokenData.usertype);
            localStorage.setItem('access_token', tokenData.access_token);
            localStorage.setItem('refresh_token', tokenData.refresh_token);
        })
            .addCase(userActions_1.fOwnerLogin.rejected, (state, action) => {
            var _a;
            state.loginLoading = false;
            state.loginError = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to login';
            state.token = [];
        });
    }
});
exports.userRegisterSlice = (0, toolkit_1.createSlice)({
    name: 'user/register',
    initialState: initialRegisterState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.register.pending, (state) => {
            state.isRegister = false;
            state.registerLoading = true;
            state.registerError = null;
        })
            .addCase(userActions_1.register.fulfilled, (state) => {
            state.isRegister = true;
            state.registerLoading = false;
            state.registerError = null;
        })
            .addCase(userActions_1.register.rejected, (state, action) => {
            var _a;
            state.isRegister = false;
            state.registerLoading = false;
            state.registerError = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to register';
        });
    }
});
exports.businessLoginSlice = (0, toolkit_1.createSlice)({
    name: 'business/login',
    initialState: businessLoginState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.businessLogin.pending, (state) => {
            state.loginLoading = true;
            state.loginError = null;
        })
            .addCase(userActions_1.businessLogin.fulfilled, (state, action) => {
            const tokenData = action.payload;
            state.loginLoading = false;
            state.loginError = null;
            if (tokenData.isBusinessAvailable) {
                localStorage.setItem('isBusinessAvailable', 'true');
                localStorage.setItem('access_token', tokenData.token.access_token);
                localStorage.setItem('refresh_token', tokenData.token.refresh_token);
            }
            else {
                localStorage.setItem('isBusinessAvailable', 'false');
            }
        })
            .addCase(userActions_1.businessLogin.rejected, (state, action) => {
            var _a;
            state.loginLoading = false;
            state.loginError = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to login';
        });
    }
});
exports.logoutSlice = (0, toolkit_1.createSlice)({
    name: 'user/logout',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.logout.pending, (state) => { })
            .addCase(userActions_1.logout.fulfilled, (state) => {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('isBusinessAvailable');
        })
            .addCase(userActions_1.logout.rejected, (state, action) => { });
    }
});
exports.getUserTokenWithRefreshTokenSlice = (0, toolkit_1.createSlice)({
    name: 'user/getUserTokenWithRefreshToken',
    initialState: getUserTokenWithRefreshTokenState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.getUserTokenWithRefreshToken.pending, (state) => {
            state.token = [];
        })
            .addCase(userActions_1.getUserTokenWithRefreshToken.fulfilled, (state, action) => {
            const tokenData = action.payload;
            localStorage.setItem('access_token', tokenData.accessToken);
        })
            .addCase(userActions_1.getUserTokenWithRefreshToken.rejected, (state, action) => { });
    }
});
exports.getTokenWithRefreshTokenSlice = (0, toolkit_1.createSlice)({
    name: 'user/getTokenWithRefreshToken',
    initialState: getTokenWithRefreshTokenState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.getTokenWithRefreshToken.pending, (state) => { })
            .addCase(userActions_1.getTokenWithRefreshToken.fulfilled, (state, action) => {
            const tokenData = action.payload;
            localStorage.setItem('access_token', tokenData.accessToken);
        })
            .addCase(userActions_1.getTokenWithRefreshToken.rejected, (state, action) => { });
    }
});
exports.fetchUserSlice = (0, toolkit_1.createSlice)({
    name: 'user/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.fetch.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to fetch Users';
            state.data = [];
        });
    }
});
exports.fetchUserForOwnerSlice = (0, toolkit_1.createSlice)({
    name: 'user/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.fetchForOwner.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.fetchForOwner.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.fetchForOwner.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to fetch Users';
            state.data = [];
        });
    }
});
exports.fetchUserForFranchiseSlice = (0, toolkit_1.createSlice)({
    name: 'user/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.fetchForFranchise.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.fetchForFranchise.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.fetchForFranchise.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to fetch Users';
            state.data = [];
        });
    }
});
exports.fetchUserByIdSlice = (0, toolkit_1.createSlice)({
    name: 'user/fetchById',
    initialState: fetchUserByIdInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.fetchUserById.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.fetchUserById.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.fetchUserById.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to fetch user';
            state.data = [];
        });
    }
});
exports.createUserSlice = (0, toolkit_1.createSlice)({
    name: 'user/create',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.create.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to create user';
            state.data = [];
        });
    }
});
exports.updateUserSlice = (0, toolkit_1.createSlice)({
    name: 'user/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.update.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to update user';
            state.data = [];
        });
    }
});
exports.updateUserProfileSlice = (0, toolkit_1.createSlice)({
    name: 'user/updateUserProfile',
    initialState: updateUserProfileInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.update.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to update user profile';
            state.data = [];
        });
    }
});
exports.resetPasswordSlice = (0, toolkit_1.createSlice)({
    name: 'user/resetPassword',
    initialState: resetPasswordInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.resetPassword.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.resetPassword.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.resetPassword.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to reset password';
            state.data = [];
        });
    }
});
exports.sendOtpSlice = (0, toolkit_1.createSlice)({
    name: 'user/sendOtp',
    initialState: sendOtpInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.sendOtp.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.sendOtp.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.sendOtp.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to send otp';
            state.data = [];
        });
    }
});
exports.sendAdminOtpSlice = (0, toolkit_1.createSlice)({
    name: 'user/sendAdminOtp',
    initialState: sendOtpInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.sendAdminOtp.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.sendAdminOtp.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.sendAdminOtp.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to send otp';
            state.data = [];
        });
    }
});
exports.verifyOtpSlice = (0, toolkit_1.createSlice)({
    name: 'user/verifyOtp',
    initialState: verifyOtpInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.verifyOtp.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.verifyOtp.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.verifyOtp.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to verify otp';
            state.data = [];
        });
    }
});
exports.verifyAdminOtpSlice = (0, toolkit_1.createSlice)({
    name: 'user/verifyAdminOtp',
    initialState: verifyOtpInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userActions_1.verifyAdminOtp.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(userActions_1.verifyAdminOtp.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(userActions_1.verifyAdminOtp.rejected, (state, action) => {
            var _a;
            state.loading = false;
            state.error = (_a = action.error.message) !== null && _a !== void 0 ? _a : 'Failed to reset password';
            state.data = [];
        });
    }
});
exports.userLoginReducer = exports.userLoginSlice.reducer;
exports.userRegisterReducer = exports.userRegisterSlice.reducer;
exports.businessLoginReducer = exports.businessLoginSlice.reducer;
exports.logoutReducer = exports.logoutSlice.reducer;
exports.getUserTokenWithRefreshTokenReducer = exports.getUserTokenWithRefreshTokenSlice.reducer;
exports.getTokenWithRefreshTokenReducer = exports.getTokenWithRefreshTokenSlice.reducer;
exports.fetchUserReducer = exports.fetchUserSlice.reducer;
exports.fetchUserByIdReducer = exports.fetchUserByIdSlice.reducer;
exports.createUserReducer = exports.createUserSlice.reducer;
exports.updateUserReducer = exports.updateUserSlice.reducer;
exports.updateUserProfileReducer = exports.updateUserProfileSlice.reducer;
exports.resetPasswordReducer = exports.resetPasswordSlice.reducer;
exports.sendOtpReducer = exports.sendOtpSlice.reducer;
exports.verifyOtpReducer = exports.verifyOtpSlice.reducer;
exports.adminLoginReducer = exports.adminLoginSlice.reducer;
exports.fOwnerLoginReducer = exports.fOwnerLoginSlice.reducer;
exports.sendAdminOtpReducer = exports.sendAdminOtpSlice.reducer;
exports.verifyAdminOtpReducer = exports.verifyAdminOtpSlice.reducer;
exports.fetchUserForOwnerReducer = exports.fetchUserForOwnerSlice.reducer;
exports.fetchUserForFranchiseReducer = exports.fetchUserForFranchiseSlice.reducer;
